"use client";

import React from "react";

import { DealType } from "@/enums/dealType";
import { useUserRole } from "@/hooks/useUserRole";
import { Filter } from "@/types/SearchFilter.types";
import { SearchPanel } from "@/ui/SearchPanel";

interface EnhancedSearchPanelProps {
  dealType: DealType;
  initialFilters?: Partial<Filter>;
  header?: string;
  localizedLocationString?: string;
}

export function EnhancedSearchPanel({
  dealType,
  initialFilters,
  header,
  localizedLocationString,
}: EnhancedSearchPanelProps) {
  const { isRealtor } = useUserRole();

  // Both realtors and non-realtors use the same SearchPanel
  // Extended filters are conditionally shown based on user role inside SearchPanel
  return (
    <SearchPanel
      dealType={dealType}
      initialFilters={initialFilters}
      header={header}
      localizedLocationString={localizedLocationString}
    />
  );
}
